import{jsxs as e,jsx as r}from"react/jsx-runtime";import t,{useState as l,useRef as i,useEffect as a,isValidElement as n}from"react";import d from"tailwind-styled-components";import{getChildrenByType as o}from"react-nanny";import s from"clsx";import{twString as c}from"../utils.js";const p=d.div``,u=d.div`
  flex
  items-center
  justify-center
  mb-4
  w-full
`,b=d.div`
  flex
  flex-shrink-0
  relative
`,m=d.div`
  bg-black/5
  flex-grow
  h-[1px]

  dark:bg-white/10
`,f=d.button`
  appearance-none
  border-none
  px-4
  py-2
  rounded-full
  text-sm
  relative
  z-10
`,h=d.span`
  absolute
  pointer-events-none
  transition-all
`,g=d.div`
  w-full
  relative
  z-20
`,y=c`
  bg-black/5
  items-center
  mx-1
  overflow-hidden
  p-[1px]
  rounded-full
  shadow-inner

  dark:bg-gray-600/50
`,v=c`
  translate-y-[1px]
`,x=c`
  bg-white
  h-[calc(100%_-_2px)]
  rounded-full
  shadow-md

  dark:bg-gray-500
`,w=c`
  bottom-0
  h-[2px]
  rounded-t-sm

  dark:bg-brand-primary-light
`,k=c`
  bg-white
  h-full
  rounded-t
  shadow-md

  dark:bg-gray-700
`,C=({activeColor:d,activeId:c,children:N,inactiveColor:j,onTabChange:P,tabClassName:q,type:z="pills",...B})=>{const[R,S]=l(c),[T,_]=l({width:0,left:0}),[D,E]=l(!1),I=o(N,C.Panel),V=i(I[0]),$=i(null),A={...T,...d&&"underline"===z?{backgroundColor:d}:{}},F={...d?{color:d}:{}},G=s({[y]:"pills"===z,[v]:"underline"===z}),H=s({[x]:"pills"===z,[w]:"underline"===z,"bg-brand-primary":"underline"===z&&!d,"[background-color:aliceblue]":"underline"===z&&d,[k]:"card"===z}),J=s({"items-end border-b border-b-black/5 dark:border-gray-600 justify-start":"underline"===z,"items-end justify-start mb-0":"card"===z}),K=s({"shadow-lg p-4 bg-white dark:bg-gray-700 rounded-b":"card"===z,"rounded-t":"card"===z&&!D,"rounded-tr":"card"===z&&D});return a((()=>{n(V.current)&&!c&&S(V.current.props.id)}),[V,c]),a((()=>{c&&S(c)}),[c]),a((()=>{if($.current){const e=$.current.getBoundingClientRect(),r=$.current.querySelector(".tab-active")?.getBoundingClientRect(),{left:t,width:l}=r||{left:0,width:0};_({left:t-e.left,width:l}),E(null!==$.current.querySelector(".tab-active:first-child"))}}),[R,z,q]),e(p,{...B,children:[e(u,{className:J,children:["pills"===z&&r(m,{}),e(b,{className:G,ref:$,role:"tablist",children:[I.map((e=>{if(n(e)){const l=s(q,{"font-medium dark:text-gray-200 tab-active":R===e.props.id,"text-brand-primary":R===e.props.id&&!d,"dark:text-gray-500":R!==e.props.id});return r(f,{"aria-controls":e.props.id,"aria-selected":R===e.props.id,className:l,href:`#${e.props.id}`,onClick:(t=e.props.id,e=>{e.preventDefault(),c||S(t),"function"==typeof P&&t!==R&&P(t)}),role:"tab",style:R===e.props.id?F:j?{color:j}:{},children:e.props.title},e.props.id)}var t;return null})),r(h,{className:H,style:A})]}),"pills"===z&&r(m,{})]}),r(g,{className:K,children:I.filter((e=>t.isValidElement(e)&&e.props.id===R))})]})},N=({id:e,title:t,children:l,...i})=>r("div",{role:"tabpanel",...i,children:l});N.displayName="Tabs.Panel",C.Panel=N;export{C as default};
